import { render, staticRenderFns } from "./BatchListPage.vue?vue&type=template&id=0760ed3d&"
import script from "./BatchListPage.vue?vue&type=script&lang=ts&"
export * from "./BatchListPage.vue?vue&type=script&lang=ts&"
import style0 from "./BatchListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports